import { render, staticRenderFns } from "./customUpload.vue?vue&type=template&id=1458640d&scoped=true&"
import script from "./customUpload.vue?vue&type=script&lang=js&"
export * from "./customUpload.vue?vue&type=script&lang=js&"
import style0 from "./customUpload.vue?vue&type=style&index=0&id=1458640d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1458640d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1458640d')) {
      api.createRecord('1458640d', component.options)
    } else {
      api.reload('1458640d', component.options)
    }
    module.hot.accept("./customUpload.vue?vue&type=template&id=1458640d&scoped=true&", function () {
      api.rerender('1458640d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/customUpload.vue"
export default component.exports